import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaWhatsapp, FaHeart } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-social">
          <a href="https://facebook.com/sanchitisfitnessstudio" target="_blank" rel="noopener noreferrer">
            <FaFacebook />
          </a>
          <a href="https://instagram.com/sanchitisfitnessstudio" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          <a href="https://twitter.com/sanchitisfitness" target="_blank" rel="noopener noreferrer">
            <FaTwitter />
          </a>
          <a href="https://youtube.com/sanchitisfitnessstudio" target="_blank" rel="noopener noreferrer">
            <FaYoutube />
          </a>
          <a href="https://wa.me/919370020026" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp />
          </a>
        </div>
        
        <div style={{ marginBottom: '1rem' }}>
          <p style={{ marginBottom: '0.5rem', fontSize: '1.1rem', fontWeight: 'bold' }}>
            🕉️ Sanchiti's Fitness Studio
          </p>
          <p style={{ fontSize: '0.9rem', opacity: 0.8 }}>
            Transform your life through the ancient practice of yoga
          </p>
        </div>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
          gap: '2rem', 
          margin: '2rem 0',
          textAlign: 'left'
        }}>
          <div>
            <h4 style={{ marginBottom: '1rem', color: '#ffa500' }}>Quick Links</h4>
            <p style={{ margin: '0.5rem 0' }}><a href="#home" style={{ color: 'white', textDecoration: 'none' }}>🏠 Home</a></p>
            <p style={{ margin: '0.5rem 0' }}><a href="#asanas" style={{ color: 'white', textDecoration: 'none' }}>🧘‍♀️ Yoga Asanas</a></p>
            <p style={{ margin: '0.5rem 0' }}><a href="#about" style={{ color: 'white', textDecoration: 'none' }}>ℹ️ About Us</a></p>
            <p style={{ margin: '0.5rem 0' }}><a href="#contact" style={{ color: 'white', textDecoration: 'none' }}>📞 Contact</a></p>
          </div>
          
          <div>
            <h4 style={{ marginBottom: '1rem', color: '#ffa500' }}>Classes</h4>
            <p style={{ margin: '0.5rem 0' }}>🌅 Hatha Yoga</p>
            <p style={{ margin: '0.5rem 0' }}>🌊 Vinyasa Flow</p>
            <p style={{ margin: '0.5rem 0' }}>💪 Ashtanga Yoga</p>
            <p style={{ margin: '0.5rem 0' }}>😌 Restorative Yoga</p>
          </div>
          
          <div>
            <h4 style={{ marginBottom: '1rem', color: '#ffa500' }}>Special Programs</h4>
            <p style={{ margin: '0.5rem 0' }}>🧘‍♂️ Meditation Classes</p>
            <p style={{ margin: '0.5rem 0' }}>🤰 Prenatal Yoga</p>
            <p style={{ margin: '0.5rem 0' }}>👥 Private Sessions</p>
            <p style={{ margin: '0.5rem 0' }}>🏕️ Yoga Retreats</p>
          </div>
          
          <div>
            <h4 style={{ marginBottom: '1rem', color: '#ffa500' }}>Contact Info</h4>
            <p style={{ margin: '0.5rem 0' }}>📱 +91 95037 00022</p>
            <p style={{ margin: '0.5rem 0' }}>📧 info@sanchitisfitness.com</p>
            <p style={{ margin: '0.5rem 0' }}>📍 Nagpur, Maharashtra</p>
            <p style={{ margin: '0.5rem 0' }}>🕐 8 AM - 9 PM (Mon-Fri)</p>
          </div>
        </div>
        
        <div style={{ 
          borderTop: '1px solid rgba(255,255,255,0.2)', 
          paddingTop: '1rem', 
          marginTop: '2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem' }}>
            © 2025 Sanchiti's Fitness Studio. All rights reserved.
          </p>
          <p style={{ margin: 0, fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            Made with <FaHeart style={{ color: '#ff6b6b' }} /> for yoga lovers
          </p>
        </div>
        
        <div style={{ 
          marginTop: '1rem', 
          padding: '1rem', 
          background: 'rgba(255,255,255,0.1)', 
          borderRadius: '10px',
          textAlign: 'center'
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem', fontStyle: 'italic' }}>
            "Yoga is not about touching your toes. It is about what you learn on the way down." - Judith Hanson Lasater
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
